module.exports = __webpack_public_path__ + "media/Stepmother.17f530c7.mp3";